import { CandidatesAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';

/**
 * Fetches candidates and transforms to entity list
 *
 * @param {import('../types/Candidates.parameters').IGetCandidatesPayload} payload - Request payload
 * @returns {Promise<{ data: import('../types/Candidates').ICandidateEntity[], page: number, pageSize: number, total: number }>} Candidates entity list with pagination
 */
export const getCandidates = async ({ postingId, page, pageSize, status, name }) => {
  const response = await PermanentJobsApi.getCandidates({
    postingId,
    page,
    pageSize,
    status,
    name,
  });

  return CandidatesAdapters.toCandidatesResponse(response);
};
